import { HIDE_IDS, PEEKER_IDS, type HideId, type PeekerId } from '../assets/art/ids'
import { pickIndex } from './shuffle'

export const REVEAL_RESET_MS = 2000
export const IDLE_PROMPT_MS = 8000

export { HIDE_IDS, PEEKER_IDS }
export type { HideId, PeekerId }

export function pickHideIndex(rand: () => number = Math.random): number {
  return pickIndex(HIDE_IDS.length, rand)
}

export function pickPeekerIndex(
  except: number | null = null,
  rand: () => number = Math.random,
): number {
  if (except === null) return pickIndex(PEEKER_IDS.length, rand)
  if (PEEKER_IDS.length <= 1) return 0
  let next = pickIndex(PEEKER_IDS.length, rand)
  if (next === except) next = (next + 1) % PEEKER_IDS.length
  return next
}
